module.exports = __webpack_public_path__ + "static/media/geoportal.5d48a6e9.png";